module.exports = __webpack_public_path__ + "static/media/mask (1).34cf2fe7.png";